import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BrandLogo } from "@/components/Brand";
import { API_BASE } from "@/lib/api";

/** `/jobs` — every Live campaign with its public page switched on. No session, no cookie, no app
 *  shell: the same kind of door as `/apply`. */
export default function Jobs() {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    axios.get(`${API_BASE}/public/jobs`)
      .then(({ data: d }) => setData(d))
      .catch(() => setFailed(true));
  }, []);

  useEffect(() => {
    if (!data) return;
    document.title = "Jobs at goSTOPS";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = data.noindex ? "noindex" : "index,follow";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, [data]);

  const campaigns = data?.campaigns || [];

  return (
    <div className="min-h-screen bg-background" data-testid="public-jobs-page">
      <header className="border-b">
        <div className="mx-auto flex h-14 max-w-3xl items-center px-4">
          <BrandLogo className="h-7" />
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-8">
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">Jobs at goSTOPS</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          हमारे होस्टल में काम · free stay and meals on duty days
        </p>

        {failed && <p className="mt-8 text-sm text-muted-foreground" data-testid="public-jobs-error">Could not load the openings. Please try again.</p>}
        {data && campaigns.length === 0 && (
          <p className="mt-8 rounded-xl border bg-card p-6 text-sm text-muted-foreground" data-testid="public-jobs-empty">
            No openings are advertised right now. Please check back soon.
          </p>
        )}

        <div className="mt-8 space-y-4">
          {campaigns.map((c) => (
            <Link key={c.slug} to={`/jobs/${c.slug}`} data-testid={`public-jobs-card-${c.slug}`}
              className="block rounded-2xl border p-5 transition-all hover:-translate-y-0.5 hover:shadow-md">
              <p className="font-display text-xl font-semibold">{c.name}</p>
              <p className="mt-1.5 text-sm text-muted-foreground">
                {c.jobs.map((j) => j.title_en).filter(Boolean).join(" · ")}
              </p>
              <p className="mt-2 text-[11px] text-muted-foreground">
                {c.jobs.length} role{c.jobs.length === 1 ? "" : "s"}
                {c.end_date ? ` · apply by ${c.end_date}` : ""}
              </p>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
